import React from 'react';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import GenericDetail from 'gui/components/listPage/components/ad/components/genericDetail';

interface IAdRoomSize {
  people: number;
}

const AdRoomSize = (props: IAdRoomSize) => (
  <GenericDetail
    title="מספר אנשים"
    icon={SupervisorAccountIcon}
  >
    {props.people}
  </GenericDetail>
);

AdRoomSize.defaultProps = {
  people: 0,
};
export default AdRoomSize;
